import { SelectOption } from './../components/dialogs/modal-select-dialog/modal-select-dialog.service';
import { Injectable } from '@angular/core';

export type SymbolOptionType = 'point' | 'line' | 'polygon';

@Injectable({
  providedIn: 'root'
})
export class GeomSymsService {

  private symbolSizeOptions: Array<SelectOption> = [
    { label: 'Smallest', value: '1' },
    { label: 'Small', value: '2' },
    { label: 'Medium', value: '3' },
    { label: 'Large', value: '4' },
    { label: 'Larger', value: '5' },
    { label: 'Largest', value: '6' }
  ];
  private optionsProviders: { [key in SymbolOptionType]: Array<SelectOption> } = {
    'point': [
      { label: 'Select a Symbol', value: '' },
      { label: 'Point', value: 'default' },
      { label: 'Tent', value: 'tent' },
      { label: 'Triangle', value: 'triangle' },
      { label: 'Square', value: 'square' },
      { label: 'Star', value: 'star' },
      { label: 'Diamond', value: 'diamond' },
      { label: 'House', value: 'house' },
      { label: 'x - Circle', value: 'circlex_fnt' },
      { label: 'x Thin', value: 'cross_fnt' },
      { label: 'x - Heavy', value: 'x_fnt' },
      { label: 'Hospital Cross', value: 'hospital_fnt' },
      { label: 'Custom', value: 'custom' }
    ],
    'line': [
      { label: 'Solid', value: 'default' },
      { label: 'Arrow - End', value: 'complex_arrow_end' },
      { label: 'Arrow - End (Reversed)', value: 'complex_arrow_end_rev' },
      { label: 'Arrow - Start', value: 'complex_arrow_start' },
      { label: 'Arrow - Start (Reversed)', value: 'complex_arrow_start_rev' },
      { label: 'Arrow - Start and End', value: 'complex_arrow_start_end' },
      { label: 'Arrow - Middle Left', value: 'complex_arrow_middle_left' },
      { label: 'Arrow - Middle Right', value: 'complex_arrow_middle_right' },
      { label: 'Border', value: 'border' },
      { label: 'Border (.5x)', value: 'border_half' },
      { label: 'Border (2x)', value: 'border_2x' },
      { label: 'Center Line', value: 'center' },
      { label: 'Center Line (.5x)', value: 'center_half' },
      { label: 'Center Line (2x)', value: 'center_2x' },
      { label: 'Dashes', value: 'dashes' },
      { label: 'Dotted', value: 'dotted' },
      { label: 'Dotted Spaced', value: 'dotted_spaced' },
      { label: 'Dot and Dash', value: 'dot_and_dash' },
      { label: 'Dot and Long Dash', value: 'dot_and_long_dash' },
      { label: 'Dashes Short', value: 'dashes_short' },
      { label: 'Dashes Long', value: 'dashes_long' },
      { label: 'Dashes Medium', value: 'dashes_medium' },
      { label: 'Flow Line', value: 'flow' },
      { label: 'Nautical - Single', value: 'complex_nautical_single' },
      { label: 'Phantom', value: 'phantom' },
      { label: 'Phantom (.5x)', value: 'phantom_half' },
      { label: 'Phantom (2x)', value: 'phantom_2x' },
      { label: 'Rail: Single Track', value: 'complex_rail' },
      { label: 'Railroad', value: 'complex_railroad' },
      { label: 'Railroad - In Street', value: 'complex_railroad_in_street' },
      { label: 'Railroad - Multi-track', value: 'complex_railroad_multi' },
      { label: 'Railroad - Trunkline', value: 'complex_railroad_trunkline' },
      { label: 'Square Tooth Filled', value: 'complex_nautical_single_4' },
      { label: 'Square Tooth Filled 2', value: 'complex_nautical_single_2' },
      { label: 'Square Tooth Hollow', value: 'complex_nautical_single_3' }
    ],
    'polygon': [
      { label: "Solid", value: "default" },
      { label: "Hatched Horizontal", value: "hatch_horizontal" },
      { label: "Hatched Vertical", value: "hatch_vertical" },
      { label: "Hatched Right", value: "hatch_right" },
      { label: "Hatched Left", value: "hatch_left" },
      { label: "Stripe Right", value: "stripe_right" },
      { label: "Stripe Right (2x)", value: "stripe_right_2x" },
      { label: "Stripe Left", value: "stripe_left" },
      { label: "Stripe Left (2x)", value: "stripe_left_2x" },
      { label: "Grid", value: "grid" },
      { label: "Grid Angled", value: "grid_angled" },
      { label: "Grid Inverted", value: "grid_inverted" },
      { label: "Dotted (.5x)", value: "complex_dotted_fill_half" },
      { label: "Dotted", value: "complex_dotted_fill" },
      { label: "Dotted (2x)", value: "complex_dotted_fill_2x" },
      { label: "Screen", value: "complex_screen" },
      { label: "Outline - Border Line", value: "outline_border" },
      { label: "Outline - Border Line (.5x)", value:  "outline_border_half"},
      { label: "Outline - Border Line (2x)", value: "outline_border_2x" },
      { label: "Outline - Center Line", value: "outline_center" },
      { label: "Outline - Center Line (.5x)", value: "outline_center_half" },
      { label: "Outline - Center Line (2x)", value: "outline_center_2x" },
      { label: "Outline - Dashes", value: "outline_dashes" },
      { label: "Outline - Dashes Short", value: "outline_dashes_short" },
      { label: "Outline - Dashes Medium", value: "outline_dashes_medium" },
      { label: "Outline - Dashes Long", value: "outline_dashes_long" },
      { label: "Outline - Dotted", value: "outline_dotted" },
      { label: "Outline - Dotted Spaced", value: "outline_dotted_spaced" },
      { label: "Outline - Dot and Dash", value: "outline_dot_and_dash" },
      { label: "Outline - Dot and Long Dash", value: "outline_dot_and_long_dash" },
      { label: "Outline - Flow Line", value: "outline_flow" },
      { label: "Outline - Nautical Single", value: "complex_nautical_single" },
      { label: "Outline - Phantom", value: "outline_phantom" },
      { label: "Outline - Phantom (.5x)", value: "outline_phantom_half" },
      { label: "Outline - Phantom (2x)", value: "outline_phantom_2x" },
      { label: "Outline - Railroad", value: "complex_railroad" },
      { label: "Outline - Railroad In Street", value: "complex_railroad_in_street" },
      { label: "Outline - Railroad Multi-track", value: "complex_railroad_multi" },
      { label: "Outline - Railroad Railroad Trunkline", value: "complex_railroad_trunkline" },
      { label: "Outline - Square Tooth", value: "complex_square_tooth" },
      { label: "Outline - Square Tooth Hollow", value: "complex_square_tooth_hollow" },
      { label: "Outline - Square Tooth Filled", value: "complex_square_tooth_filled" }
    ]
  }
  constructor() { }

  GetOptionProvider(type: SymbolOptionType) {
    return this.optionsProviders[type];
  }
  GetSymbolSizeProvider() {
    return this.symbolSizeOptions;
  }

}
